"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseService = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var purchase_queries_1 = require("./purchase.queries");
var base_public_service_1 = require("../base-public-service");
var payment_type_1 = require("../../mappers/payment-type");
var globalTypes_1 = require("../generated/globalTypes");
var purchase_status_1 = require("../../mappers/purchase-status");
var PurchaseService = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PurchaseService, _super);
    function PurchaseService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PurchaseService.getIdByPaymentType = function (videoId, channelId, paymentType) {
        var _a;
        return (_a = {},
            _a[enums_1.PaymentType.RENT] = videoId,
            _a[enums_1.PaymentType.PURCHASE] = videoId,
            _a[enums_1.PaymentType.MEMBER_ONLY] = videoId,
            _a[enums_1.PaymentType.SUBSCRIPTION] = channelId,
            _a[enums_1.PaymentType.PLAN] = channelId,
            _a)[paymentType];
    };
    PurchaseService.prototype.createOrder = function (videoId, channelId, paymentType) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var id, response;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = PurchaseService.getIdByPaymentType(videoId, channelId, paymentType);
                        return [4 /*yield*/, this.client.request(purchase_queries_1.CREATE_ORDER, {
                                id: id,
                                type: payment_type_1.paymentTypeMapper.toGql(paymentType),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.purchase.order.create.entity.id];
                }
            });
        });
    };
    PurchaseService.prototype.getOrderStatus = function (videoId, channelId, paymentType) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var id, purchaseTypeMap, response;
            var _a;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = PurchaseService.getIdByPaymentType(videoId, channelId, paymentType);
                        purchaseTypeMap = (_a = {},
                            _a[enums_1.PaymentType.RENT] = globalTypes_1.PurchaseType.RENT,
                            _a[enums_1.PaymentType.PURCHASE] = globalTypes_1.PurchaseType.SALE,
                            _a[enums_1.PaymentType.SUBSCRIPTION] = globalTypes_1.PurchaseType.SUBSCRIPTION,
                            _a);
                        return [4 /*yield*/, this.client.request(purchase_queries_1.GET_ORDER_STATUS, {
                                id: id,
                                type: purchaseTypeMap[paymentType],
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, purchase_status_1.purchaseStatusMapper.toVod(response.purchase.status)];
                }
            });
        });
    };
    PurchaseService.prototype.cancelOrder = function (channelId) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var response;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(purchase_queries_1.CANCEL_ORDER, {
                            id: channelId
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.purchase.cancel.status === globalTypes_1.MutationStatus.SUCCESS];
                }
            });
        });
    };
    return PurchaseService;
}(base_public_service_1.BasePublicService));
exports.PurchaseService = PurchaseService;
//# sourceMappingURL=purchase.js.map